import { useMemo } from "react";
// Applies render order to meshes with transparent materials
export const useApplyRenderOrderToModel = (object, renderOrder) => {
    return useMemo(() => {
        object.traverse((node) => {
            if ((node.isSkinnedMesh || node.isMesh) &&
                typeof renderOrder !== "undefined") {
                const mesh = node;
                const materialArray = Array.isArray(mesh.material)
                    ? mesh.material
                    : [mesh.material];
                let meshIsTransparent = false;
                for (let i = 0; i < materialArray.length; i++) {
                    if (materialArray[i].transparent)
                        meshIsTransparent = true;
                }
                if (meshIsTransparent)
                    mesh.renderOrder = renderOrder;
            }
        });
        return object;
    }, [object, renderOrder]);
};
